<template>
    <div class="realName home_bg">
        <div style="width: 100%;height: 80px;"></div>
        <div class="main">
            <div class="steps">
                <div class="step wx_step" :class="{'active_step':stepShow}">基础信息</div>
                <div class="step">
                    <img :src="stepShow?stepImage:nextImage" alt="">
                </div>
                <div class="step wx_step" :class="{'active_step':!stepShow}">园区作物配置</div>
            </div>
            <div class="wx_box">
                <div class="wx_main" v-if="stepShow">
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
                    <div class="form">
                        <div class="item">
                            <div class="label">*名称:</div>
                            <div class="input">
								 <el-form-item label="" prop="name">
                                <el-input v-model="ruleForm.name" placeholder="请输入名称"></el-input>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*地址:</div>
                            <div class="input flexInput">
                                <div class="select_item" >
                                    <div class="select_label">省份</div>
									 <el-form-item label="" prop="province_id">
                                  <el-select v-model="ruleForm.province_id" placeholder="请选择" @change="changeRegionProvince">
                                      <el-option
                                              v-for="item in provinceList"
                                              :key="item.id"
                                              :label="item.name"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
									</el-form-item>
                                </div>
                                <div class="select_item province">
                                    <div class="select_label">城市</div>
									<el-form-item label="" prop="city_id">
									<el-select v-model="ruleForm.city_id" placeholder="请选择" @change="changeRegionCity">
									    <el-option
									            v-for="item in cityList"
									            :key="item.id"
									            :label="item.name"
									            :value="item.id">
									    </el-option>
									</el-select>
									
									</el-form-item>
                                </div>
								  <div class="select_item province">
							  <div class="select_label">城市</div>
								<el-form-item label="" prop="district_id">
								<el-select v-model="ruleForm.district_id" placeholder="请选择">
								    <el-option
								            v-for="item in districtList"
								            :key="item.id"
								            :label="item.name"
								            :value="item.id">
								    </el-option>
								</el-select>
								
								</el-form-item>
                            </div>
							</div>
                        </div>
                        <div class="item">
                            <div class="label">街道地址:</div>
                            <div class="input">
								<el-form-item label="" prop="street">
                                <el-input v-model="ruleForm.street" placeholder="请输入街道地址"></el-input>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*联系人:</div>
                            <div class="input">
								<el-form-item label="" prop="contact_username">
                                <el-input v-model="ruleForm.contact_username" placeholder="请输入联系人"></el-input>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*联系电话:</div>
                            <div class="input">
								<el-form-item label="" prop="contact_mobile">
                                <el-input v-model="ruleForm.contact_mobile" placeholder="请输入联系电话"></el-input>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*建立时间:</div>
                            <div class="input">
								<el-form-item label="" prop="build_time">
                                <el-date-picker
                                        v-model="ruleForm.build_time"
                                        type="date"
                                        placeholder="请选择建立时间">
                                </el-date-picker>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*园区面积:</div>
                            <div class="input input_flex">
                                <div class="flex_item">
                                    <span>占地面积:</span>
									<el-form-item label="" prop="floor_area">
                                    <el-input v-model="ruleForm.floor_area"></el-input>
										</el-form-item>
                                    <span>平方千米</span>
                                </div>
                                <div class="flex_item">
                                    <span>种植面积:</span>
                                   <el-form-item label="" prop="plant_area">
                                   <el-input v-model="ruleForm.plant_area"></el-input>
                                   	</el-form-item>
                                    <span>亩</span>
                                </div>
								<div class="flex_item">
								    <span>植株数量:</span>
								   <el-form-item label="" prop="crop_number">
								   <el-input v-model="ruleForm.crop_number"></el-input>
								   	</el-form-item>
								    <span>株</span>
								</div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*是否有滴灌设备:</div>
                            <div class="input">
								<el-form-item label="" prop="is_device">
                                <el-radio-group v-model="ruleForm.is_device">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="2" >否</el-radio>
                                </el-radio-group>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">*园区简介:</div>
                            <div class="top_tips">一句话介绍</div>
                            <div class="input">
								<el-form-item label="" prop="intro">
                                <el-input v-model="ruleForm.intro" placeholder="请输入介绍"></el-input>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">详细介绍</div>
                            <div class="input">
									<el-form-item label="" prop="content">
                                <el-input type="textarea" :autosize="{ minRows: 4}" v-model="ruleForm.content" placeholder="请输入详细介绍，字数300字数以内！"></el-input>
								</el-form-item>
                            </div>
                        </div>
                        <div class="item">
                            <div class="label">照片:</div>
                            <div class="top_tips">顶部图片</div>
                            <div class="flies">
                                <el-upload
										:action="uploadAction"
										:headers="myHeaders"
                                        :on-success="handleTopSuccess"
                                        :before-upload="beforeTopUpload"
                                        :show-file-list="false"
                                        :file-list="topfileList">
                                    <div class="topfile">
                                        <img :src="ruleForm.top_image" v-if="topfileList.length>0" style="width: 427px; height: 60px;">
                                    </div>
                                </el-upload>
                            </div>
                            <div class="tips">提示：只能上传一张jpg、png格式图片，大小尺寸为：1280*180</div>
                            <div class="tips">封面图片</div>
                            <div class="flies cover">
                                <el-upload
                                        :action="uploadAction"
                                        :on-success="handleCoverSuccess"
										:headers="myHeaders"
                                        :before-upload="beforeCoverUpload"
                                        :show-file-list="false"
                                        :file-list="coverfileList">
                                    <div class="topfile">
                                        <img :src="ruleForm.cover_image" v-if="coverfileList.length>0" style="width: 427px; height: 240px;">
                                    </div>
                                </el-upload>
                            </div>
                            <div class="tips">提示：只能上传一张jpg、png格式图片，大小尺寸为：1280*180.<br> 封面图片尺寸大小为：1280*720.如果不传，为系统默认图片。</div>
                        </div>
                    </div>
                    <div class="btns" v-if="is_check!=1">
                        <el-button @click="submit('ruleForm',1)" >保存</el-button>
					   <el-button @click="submit('ruleForm',2)" class="again" >下一步</el-button>
                    </div>
					<div class="btns" v-if="is_check==1">
					    <el-button @click="modify('ruleForm',1)" >保存</el-button>
					   <el-button @click="modify('ruleForm',2)" class="again" >下一步</el-button>
					</div>
					</el-form>
                </div>
<!--                园区作物配置-->
                <div class="wx_main table_main" v-else>
                    <el-table :data="tableData" class="wx_table" :row-class-name="tableRowClassName">
                        <el-table-column prop="dict_name" label="作物大类"></el-table-column>
                        <el-table-column prop="crop_name" label="品种名"></el-table-column>
                        <el-table-column label="操作">
                           <template slot-scope="{row,$index}">
                               <!--  <el-button class="edit_btn" type="primary" plain size="small" @click="addShow = true">编辑</el-button>
                               <el-button class="del_btn" type="danger" plain size="small" @click="delShow = true">删除</el-button>-->
							   <el-button class="edit_btn" type="primary" plain size="small" @click="handleEdit(row,$index)">编辑</el-button>
							   <el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(row,$index)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="btns">
						 <el-button  @click="stepShow =true">上一步</el-button>
                        <el-button  @click="addShow = true">添加作物</el-button>
                        <el-button class="again" @click="returnIndex()">返回园区</el-button>
                    </div>
                </div>
            </div>
        </div>
        <!--        保存弹窗-->
        <WxMessageBox :show="saveShow" @save="save" @canse="canse">
            <div slot="content">
                <p class="word">你已经成功保存！</p>
            </div>
        </WxMessageBox>
<!--        点击建立园区-->
        <WxMessageBox :show="establishShow" @save="establishsave" @canse="establishcanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定建立园区，确定后，</p>
                    <p>园区将建立成功！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--        删除弹窗-->
        <WxMessageBox :show="delShow" @save="delsave" @canse="delcanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你是否确定删除此项，删除后，</p>
                    <p>将不可恢复！</p>
                </div>
            </div>
        </WxMessageBox>
        <!--        点击确定弹窗-->
        <WxMessageBox :show="determineShow" @save="determinesave" @canse="determinecanse">
            <div slot="content">
                <p class="word">你是否确定本次操作！</p>
            </div>
        </WxMessageBox>
<!--        点击确定，相同品种，同样的路径-->
        <WxMessageBox :show="equallyShow" @save="equallysave" @canse="equallycanse">
            <div slot="content">
                <div class="word marTop">
                    <p>你已经有相同横泾的作物了，</p>
                    <p> 不可再次添加。</p>
                </div>
            </div>
        </WxMessageBox>
        <!--        添加作物弹框-->
        <WxMessageBox :show="addShow" @save="addsave" @canse="addcanse">
            <div slot="content">
                <div class="word marTop addBox">
                    <div class="wx_item">
						
                        <span class="label">作物大类</span>
						
                        <el-select v-model="cropFrom.dict_id" placeholder="请选择" size="mini" @change="changeCrop">
                            <el-option
                                    v-for="item in dict_list"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
					
                    </div>
                    <div class="wx_item">
                        <span class="label">品种名称</span>
						
                        <el-select v-model="cropFrom.crop_id" placeholder="请选择" size="mini">
                            <el-option
                                    v-for="item in crop_list"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
						
                    </div>
                </div>
            </div>
        </WxMessageBox>
    </div>
</template>

<script>
	 import {updateCheckedFarm,get_province_crop,get_region_list,createFarm,get_farm_nocheck_info,get_data_crop,create_fram_crop,delete_farm_crop,saveFarm,getFarmInfo} from '@/api/api'
	 import axios from 'axios';
    import Header from '@/components/Header';
    import WxMessageBox from '@/components/MessageBox';
    export default {
        name: "build",
        data(){
            return{
                stepShow:true,
                stepImage:require('../../../assets/images/allow_01.png'),
                nextImage:require('../../../assets/images/allow_02.png'),
                uploadAction:axios.defaults.baseURL+"/upload/image",
				//axios.defaults.baseURL
                bannerUrl:'',
				farm_crop_id:'',
			     title:'',
				 is_check:0,
				 farm_id:0,
                saveShow:false,
                delShow:false,
                establishShow:false,
                determineShow:false,
                equallyShow:false,
                addShow:false,
                countryList: [{
                    id: 1,
                    value: '中国'
                }],
				 myHeaders: {
				          authorization: "Bear "+localStorage.getItem("token")
				        },
                provinceList: [],
                cityList: [],
                districtList: [],
                topfileList:[],
                topUrl:'',
                coverfileList:[],
                coverUrl:'',
                tableData:[],
                type:'',
                typeName:'',
				dict_list:[],
                crop_list:[],
				cropFrom:{
					 dict_id:'',
					 crop_id:'',
				},
				ruleForm:{
						   name:'新希望产业园',
						   country_id:'1',
						   province_id:'',
						   city_id:'',
						   district_id:'',
						   street:'花溪街道',
						   contact_username:'牟少斌',
						   contact_mobile:'18696539501',
						   build_time:'2020-08-25',
						   floor_area:'20',
						   plant_area:'15',
						   crop_number:'1560',
						   is_device:1,
						   intro:'简介',
						   content:'',
						   top_image:'',
						   cover_image:'',
						   type:2	   
				},
				rules: {
							name: [{
									required: true,
									message: '请输入园区名称',
									trigger: 'blur'
								}
							],
							country_id: [{
									required: true,
									message: '请选择国家',
									trigger: 'change'
								}
							],
							province_id: [{
									required: true,
									message: '请选择省份',
									trigger: 'change'
								}
							],
							city_id: [{
									required: true,
									message: '请选择城市',
									trigger: 'change'
								}
							],
							street: [{
									required: true,
									message: '请输入园区所属街道',
									trigger: 'blur'
								}
							],
							contact_username: [{
									required: true,
									message: '请输入园区联系人姓名',
									trigger: 'blur'
								}
							],
							contact_mobile: [{
									required: true,
									message: '请输入园区联系电话',
									trigger: 'blur'
								}
							],
							build_time: [{
									required: true,
									message: '选择园区建立时间',
									trigger: 'blur'
								}
							],
							floor_area: [{
									required: true,
									message: '请输入园区占地面积',
									trigger: 'blur'
								}
							],
							plant_area: [{
									required: true,
									message: '请输入园区种植面积',
									trigger: 'blur'
								}
							],
							crop_number: [{
									required: true,
									message: '请输入园区植株数量',
									trigger: 'blur'
								}
							],
							is_device: [{
									required: true,
									message: '请选择园区是否有滴灌设备',
									trigger: 'blur'
								}
							],
							intro: [{
									required: true,
									message: '请输入园区一句话简介',
									trigger: 'blur'
								}
							]
							
				}
            }
        },
		mounted() {
			//console.log(axios.defaults.baseURL)
			let type=this.$route.query.type
			
			if(type==1){
				this.stepShow=false;
			}
			this.farm_id=this.$route.params.id
			this.get_farm_info(this.$route.params.id)
			this.get_province_crop()
			//this.get_farm_nocheck_info()
		},
        methods:{
			returnIndex(){
				this.$router.push("/park/detail/"+this.$route.params.id)
			},
			changeCrop(val,type=0) {
			    get_data_crop(val).then(res => {
				if(type==0){
			      this.cropFrom.crop_id=''
					}
			      this.crop_list = res
				  
			    })
			  },
			    changeRegionProvince(val,type=0) {
			        get_region_list(val).then(res => {
						if(type==0){
			           this.ruleForm["city_id"]=''
					    this.ruleForm["district_id"]=''
						}
			          this.cityList = res
					  
			        })
			      },
				  
			      changeRegionCity(val,type=0) {
			        get_region_list(val).then(res => {
					if(type==0){	   
			         this.ruleForm["district_id"]=''
					 }
			          this.districtList = res
			        })
			      },
			//获取省份列表和农作物列表
			
			get_province_crop(){
				get_province_crop().then(resp=>{
					
					this.provinceList=resp.province
					this.dict_list=resp.crop
				})
				
			},
			get_farm_info(farm_id){
			getFarmInfo(farm_id).then(resp=>{
				this.changeRegionProvince(resp.farm.province_id,1)
				this.changeRegionCity(resp.farm.city_id,1)
				 this.ruleForm=resp.farm
				 this.topfileList.push({url:resp.farm.top_image})
				  this.coverfileList.push({url:resp.farm.cover_image})
				  this.tableData=resp.crop
								  this.title=resp.farm.name
								   this.is_check=resp.farm.is_check
								   this.farm_id=parseInt(resp.farm.id)
							/*	  this.tableData=resp.user
								  this.detaliTableData=resp.crop
								  this.rule_task_list=resp.task
								  this.dict_list=resp.dict
								  this.position_list=resp.position
								  this.soil_list=resp.soil
								  this.partitionTableData=resp.partition
								  this.life_list=resp.life
								  this.pestTableData=resp.pest
								  this.remark=resp.remark
								  this.remarkForm["remarkData"]=resp.remark_list
								  this.remarkForm["word"]=resp.word
								   this.recordTableData=resp.check_record
								  
								  if(resp.info==null){
									  
								  } else{
								  this.infoForm=resp.info
								  this.skeletonMapFileList.push({path:resp.info.skeleton_map})
								  } */
			})
			},
/* 			 get_farm_nocheck_info(){
				 get_farm_nocheck_info().then(resp=>{
					 if(resp.status==1){
						  this.changeRegionProvince(resp.farm.province_id,1)
						  this.changeRegionCity(resp.farm.city_id,1)
						 this.ruleForm=resp.farm
						 this.topfileList.push({url:resp.farm.top_image})
						  this.coverfileList.push({url:resp.farm.cover_image})
						  this.tableData=resp.crop
						 console.log(this.ruleForm)
						
						
						
					 }
				 })
			 },  */     
		//新增	
			submit(formName,type){
			 this.$refs[formName].validate((valid) => {
			 //	console.log(valid)
			 	if (valid) {
			 		 createFarm(this.ruleForm).then(resp=>{
			 			if(resp.status==1){
							
							if(type==2){
								this.stepShow=false
								}else{
									this.$message.success(resp.msg);
								}
			 			}else{
			 				this.$message.error(resp.msg);
			 			}
			 			}).catch(error=>console.log(error))
			 	} else {
			 		console.log('error submit!!');
			 		return false;
			 	}
			 });
			},
			modify(formName,type){
			 this.$refs[formName].validate((valid) => {
			 //	console.log(valid)
			 	if (valid) {
			 		 updateCheckedFarm(this.farm_id,this.ruleForm).then(resp=>{
			 			if(resp.status==1){
							
							if(type==2){
								this.stepShow=false
								}else{
									this.$message.success(resp.msg);
								}
			 			}else{
			 				this.$message.error(resp.msg);
			 			}
			 			}).catch(error=>console.log(error))
			 	} else {
			 		console.log('error submit!!');
			 		return false;
			 	}
			 });
			},
			
            // 顶部图片
            handleTopSuccess(res, file) {
                this.topUrl = URL.createObjectURL(file.raw);
			   console.log(res)
			   this.ruleForm["top_image"]=res.data;
			   this.topfileList.push(res.data)
			   console.log( this.ruleForm)
            },
            beforeTopUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPng = file.type === 'image/png';
                if (!isJPG && !isPng) {
                    this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
					return false
                }else{
					return true
				}
				//console.log(file.type);
                 // return isJPG && isPng;
            },
            // 封面图片
            handleCoverSuccess(res, file) {
                this.coverUrl = URL.createObjectURL(file.raw);
				 this.ruleForm["cover_image"]=res.data;
				  this.coverfileList.push(res.data)
            },
            beforeCoverUpload(file) {
                const isJPG = file.type === 'image/jpeg';
                const isPng = file.type === 'image/png';
                if (!isJPG && !isPng) {
                    this.$message.error('上传头像图片只能是 JPG或PNG 格式!');
                   return false
               }else{
                 	return true
               }
            },
            // 保存弹窗确定
            save(){
                this.saveShow = false
            },
            // 保存弹窗取消
            canse(){
                this.saveShow = false
            },
            // 删除弹窗确定
            delsave(){
                this.delShow = false
				delete_farm_crop(this.farm_crop_id).then(resp=>{
					this.get_farm_nocheck_info();
				})
				
            },
			handleEdit(row,index){
				this.cropFrom.dict_id=row.dict_id
				this.cropFrom.crop_id=row.crop_id
				this.changeCrop(row.dict_id,1)
				this.addShow=true
			},
			handleDelete(row,index){
				
				this.delShow=true;
				this.farm_crop_id=row.id
			},
            // 删除弹窗取消
            delcanse(){
                this.delShow = false
            },
            // 点击建立园区弹窗确认
            establishsave(){
                this.establishShow = false
                this.determineShow = true
				saveFarm().then(resp=>{
					 this.$router.push('/');
				})
            },
            // 点击建立园区弹窗取消
            establishcanse(){
                this.establishShow = false
            },
            // 点击确定弹窗确认
            determinesave(){
                this.determineShow = false
				
               
            },
            // 点击确定弹窗取消
            determinecanse(){
                this.determineShow = false
            },
            // 点击确定相同品种，同样的路径弹窗确认
            equallysave(){
                this.equallyShow = false
            },
            // 点击确定相同品种，同样的路径弹窗取消
            equallycanse(){
                this.equallyShow = false
            },
            // 弹窗确认
            addsave(){
               // this.addShow = false
			   console.log(this.cropFrom)
			   create_fram_crop(this.cropFrom).then(resp=>{
				   if(resp.status==1){
					   this.addShow = false
					   this.clearCropFrom()
					   this.get_farm_nocheck_info()
				   }else{
					   this.$message.error(resp.msg);
				   }
			   })
            },
			clearCropFrom(){
				this.cropFrom["dict_id"]='';
				this.cropFrom["crop_id"]='';
			},
            // 弹窗取消
            addcanse(){
				this.clearCropFrom()
                this.addShow = false
            },
            // 表格斑马纹
            tableRowClassName({row, rowIndex}) {
                if (rowIndex % 2 !== 1) {
                    return 'single-row';
                }else{
                    return 'double-row';
                }
            }
        },
        components: {
            Header,
            WxMessageBox
        }
    }
</script>

<style lang="less">
    .realName{
        .main{
            padding: 0 30px 60px 30px;
            .steps{
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 49px 0;
                .step{
                    img{
                        width: 40px;
                        height: 40px;
                        margin: 0 20px;
                    }
                }
                .wx_step{
                    width: 300px;
                    height: 54px;
                    line-height: 54px;
                    background: #00407D;
                    border-radius: 4px;
                    text-align: center;
                    font-size: 20px;
                    font-weight: bold;
                    color: #9D9D9D;
                }
                .active_step{
                    color: #fff;
                    background: #2D99FF;
                }
            }
            .wx_box{
                margin: 0 auto;
                .wx_main{
                    padding: 55px 0 80px 17px;
                    background:radial-gradient(rgba(19, 62, 173, 0.74),rgba(5, 18, 32, 0.47));
                    background-size: cover;
                    .form{
                        width: 842px;
                        margin: 0 auto;
                        .label{
                            font-size: 18px;
                            color: #fff;
                            padding: 22px 0 15px 0;
                        }
                        .input{
                            .el-input__inner{
                                background-color: rgba(45, 153, 255, 0.3);
                                border: 0;
                                border-radius: 0;
                                color: #C0C0C0;
                                font-size: 16px;
                            }
                            .el-textarea__inner{
                                background-color: rgba(45, 153, 255, 0.3);
                                border: 0;
                                border-radius: 0;
                                color: #fff;
                                font-size: 16px;
                            }
                            .el-date-editor.el-input, .el-date-editor.el-input__inner{
                                width: 100%;
                            }
                            .el-select{
                                width: 270px;
                            }
                            .el-input__prefix{
                                display: none;
                            }
                            .el-input--prefix .el-input__inner{
                                padding-left: 15px;
                            }
                        }
                        .input_flex{
                            display: flex;
                            .flex_item{
                                display: flex;
                                align-items: center;
                                span{
                                    font-size: 18px;
                                    color: #fff;
                                }
                                .el-input{
                                    width: 109px;
                                    margin: 0 12px 0 14px;
                                }
                                &+.flex_item{
                                    margin-left: 30px;
                                }
                            }
                        }
                        .flies{
                            width: 427px;
                            height: 60px;
                            .topfile{
                                width: 427px;
                                height: 60px;
                                background: rgba(45, 153, 255, 0.3);
                                position: relative;
                                &:before{
                                    content: '';
                                    width: 40px;
                                    height: 37px;
                                    background: url("../../../assets/images/upLoad_03.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -20px;
                                    margin-top: -18.5px;
                                    z-index: 1;
                                }
                                &:after{
                                    content: '';
                                    width: 30px;
                                    height: 30px;
                                    background: url("../../../assets/images/upLoad_01.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -15px;
                                    margin-top: -15px;
                                    z-index: 2;
                                }
                                img{
                                    width: 100%;
                                }
                            }

                        }
                        .cover{
                            margin-top: 14px;
                            height: 240px;
                            .topfile{
                                height: 240px;
                                &:before{
                                    content: '';
                                    width: 70px;
                                    height: 65px;
                                    background: url("../../../assets/images/upLoad_04.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -35px;
                                    margin-top: -32.5px;
                                    z-index: 1;
                                }
                                &:after{
                                    content: '';
                                    width: 41px;
                                    height: 41px;
                                    background: url("../../../assets/images/upLoad_02.png") no-repeat;
                                    background-size: cover;
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    margin-left: -20.5px;
                                    margin-top: -20.5px;
                                    z-index: 2;
                                }
                            }
                        }
                        .top_tips{
                            font-size: 14px;
                            color: #858FA9;
                            padding-bottom: 8px;
                        }
                        .tips{
                            font-size: 14px;
                            color: #858FA9;
                            padding-top: 8px;
                        }
                        .flexInput{
                            display: flex;
                            align-items: flex-end;
                            .select_label{
                                font-size: 16px;
                                color: #fff;
                                padding-bottom: 12px;
                            }
                        }
                        .province{
                            margin: 0 16px;
                        }
                    }
                    .btns{
                        width: 842px;
                        padding-top: 55px;
                        display: flex;
                        justify-content: space-between;
                        margin: 0 auto;
                        .el-button{
                            width: 410px;
                            height: 48px;
                            background: #2D99FF;
                            font-size: 18px;
                            font-weight: 400;
                            color: #fff;
                            border: 0;
                            border-radius: 0;
                        }
                        .again{
                            background: #00A1E6;
                        }
                    }
                }
                .table_main{
                    padding-left: 24px;
                    padding-right: 34px;
                    .wx_table{
                        margin-bottom: 55px;
                    }
                }
            }
        }
        .word{
            margin-top: 88px;
        }
        .marTop{
            margin-top: 65px;
        }
        .addBox{
            .wx_item{
                margin-bottom: 30px;
                span.label{
                    width: 64px;
                    font-size: 16px;
                    font-weight: 400;
                    color: #FFFFFF;
                    padding-right: 24px;
                }
            }
        }
        .el-select{
            width: 242px;
            background: rgba(45, 153, 255, 0.3116);
            .el-input__inner{
                background: rgba(45, 153, 255, 0.3116);
                color: #D0D0D0;
                font-size: 14px;
                text-align: left;
                border: 0;
            }
        }
    }
</style>
